import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers"; // 假設你的根 reducer 存在於 reducers.js 中

export const store = configureStore({
  reducer: rootReducer,
});
